// Purpose: Shares the selected and keyboard-focused option treatment between
// BayHive Select and AutoComplete while leaving Lara's option geometry intact.
const selectionOptionTokens = {
  color: '{text.color}',
  selectedColor: '{text.color}',
  selectedFocusColor: '{text.color}',
};

const selectionListTokens = {
  padding: '0',
};

const selectionColorScheme = {
  light: {
    option: {
      focusBackground: '{surface.100}',
      selectedBackground: 'color-mix(in srgb, {primary.color}, white 95%)',
      selectedFocusBackground: 'color-mix(in srgb, {primary.color}, white 92%)',
    },
  },
  dark: {
    option: {
      focusBackground: '{surface.700}',
      selectedBackground: 'color-mix(in srgb, {surface.800}, {primary.color} 12%)',
      selectedFocusBackground: 'color-mix(in srgb, {surface.800}, {primary.color} 18%)',
    },
  },
};

export const selectionComponents = {
  autocomplete: {
    list: selectionListTokens,
    option: selectionOptionTokens,
    colorScheme: selectionColorScheme,
  },
  select: {
    list: selectionListTokens,
    option: selectionOptionTokens,
    colorScheme: selectionColorScheme,
  },
};

export default selectionComponents;
